import React, { useEffect, useState } from 'react';
import { useProgramOfficeData } from '../../hooks/useProgramOfficeData';
import DropDownSelector from './DropDownSelector';
import { LevelOneApprover } from '../../services/Types';
import { Typography } from '@mui/material';

interface DropDownSelectorApproverProps {
  programOfficeId: number;
  selectedApprover: LevelOneApprover | null;
  approverLevel?: number;
  onApproverChange: (approver: LevelOneApprover | null) => void;
  disabled?: boolean;
}

const DropDownSelectorApprover: React.FC<DropDownSelectorApproverProps> = ({
  programOfficeId,
  selectedApprover,
  onApproverChange,
  disabled,
}) => {
  const { getLevelOneApprovers } = useProgramOfficeData();

  const availableApprovers = getLevelOneApprovers(programOfficeId);
  const isCurrentSelectionValid = availableApprovers.some(item => item.id === selectedApprover?.id);

  // Auto-select the single approver when not already selected
  useEffect(() => {
    if (availableApprovers.length === 1 && !selectedApprover && availableApprovers[0]) {
      onApproverChange(availableApprovers[0]);
    }
  }, [availableApprovers, selectedApprover, onApproverChange]);

  return (
    <>
    <DropDownSelector
      label="Level One Approver(s)"
      currentId={selectedApprover?.id && isCurrentSelectionValid ? selectedApprover.id : 0}
      items={availableApprovers.map((approver) => ({
        id: approver.id,
        name: approver.name
      }))}
      handleCurrentId={(event) => {
        const selectedId = Number(event);
        const approver = availableApprovers.find(a => a.id === selectedId) || null;
        onApproverChange(approver);
      }}
      disabled={disabled}
    />
    {!isCurrentSelectionValid && selectedApprover?.email && <Typography sx={{ color: 'warning.main' }}>
        {selectedApprover?.email} saved but not in this list.
    </Typography>}
    </>
  );
};

export default DropDownSelectorApprover; 